module.exports = __webpack_public_path__ + "img/标题英文_荣誉资质.830bdd45.svg";